import React, { useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import moment from "moment";
import { GET_Other_income, Add_Other_income } from "Services/Requests";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { v4 as uuidv4 } from "uuid";
import Load from "Components/Loader/loader";
import { useStore } from "Store";

type questions = {
    answer: number;
    comments: string;
    question: string;
    question_id: string;
    user_answerid: string;
};

function Otherinfo() {
    const { isDisabled } = useStore((state: any) => state);
    const [isChecked, setIschecked] = useState(false);
    const [questions, setQuestions] = useState<questions[]>([]);
    const [Contrubution, setcontrubution] = useState<questions[]>([]);
    const [loading, setLoading] = useState(false);
    const [add, setAdd] = useState(true);
    const GetDetails = async () => {
        setLoading(true);
        try {
            const [response] = await Promise.all([GET_Other_income(2)]);
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                setQuestions(
                    response?.data?.questionsanswers.map((item: any) => ({
                        ...item,
                        answer: item.answer ? item.answer : 0,
                        comments: item.comments ? item.comments : "",
                    }))
                );
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);
    const changeHandler = (id: any, key: string, value: any) => {
        setQuestions((prev) =>
            prev.map((item) =>
                item.question_id !== id
                    ? item
                    : {
                          ...item,
                          [key]: value,
                          comments:
                              key == "answer"
                                  ? value == 0
                                      ? ""
                                      : item.comments
                                  : value,
                      }
            )
        );
    };

    const submitHandler = async (e: any) => {
        e.preventDefault();
        let warningTriggered = false; // Flag to track if warning is triggered

        let body: any = questions;

        for (const item of body) {
            if (
                item.answer === 1 &&
                (!item.comments || item.comments.trim() === "")
            ) {
                showWarningAlert(
                    `Comments are required for the question: "${item.question}" when the answer is yes!`
                );
                warningTriggered = true;
                break; // Stop the loop
            }
        }

        if (warningTriggered) {
            return; // Exit the function to prevent the API call
        }
        if (!isChecked) {
            return;
        }
        setLoading(true);
        try {
            const response = await Add_Other_income([...body], "expenses");
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("Expenses  updated successfully");
            } else {
                showWarningAlert(
                    response?.data.Message || "Somethign went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    return (
        <div className={Styles.Container}>
            {loading && <Load />}

            <form action="" onSubmit={submitHandler}>
                <div className={Styles.info}>
                    <h3>Other Income Info</h3>
                    {questions?.map((item) => (
                        <>
                            <div className={Styles["form-control"]}>
                                <label htmlFor="">{item.question}</label>
                                <label className="toggle">
                                    <input
                                        disabled={isDisabled}
                                        className={Styles["toggle-checkbox"]}
                                        type="checkbox"
                                        checked={
                                            item.answer == 1 ? true : false
                                        }
                                        onChange={(e) =>
                                            changeHandler(
                                                item.question_id,
                                                "answer",
                                                e.target.checked ? 1 : 0
                                            )
                                        }
                                    />
                                    <div
                                        className={
                                            Styles["toggle-switch"]
                                        }></div>
                                </label>
                            </div>
                            {item.answer == 1 && (
                                <div className={Styles["form-control_input"]}>
                                    <textarea
                                        disabled={isDisabled}
                                        value={item.comments}
                                        onChange={(e) =>
                                            changeHandler(
                                                item.question_id,
                                                "comments",
                                                e.target.value
                                            )
                                        }
                                        name=""
                                        id=""
                                        placeholder="Please Explain"
                                        rows={5}
                                    />
                                </div>
                            )}
                        </>
                    ))}
                </div>
                 {questions.length > 0 && (
                        <div
                            className={Styles["declaration"]}
                            style={{ gridColumn: "1/-1" }}>
                            <h3>
                                <input
                                    disabled={isDisabled}
                                    type="checkbox"
                                    id="pushNotification"
                                    onChange={(e) =>
                                        setIschecked(e.target.checked)
                                    }
                                />
                                <label
                                    htmlFor="pushNotification"
                                    className={Styles["checkbox-label"]}>
                                    I declare that the information in this
                                    application is true and correct{" "}
                                </label>
                            </h3>
                            <div className={Styles["save-btns"]}>
                                <button disabled={isDisabled || !isChecked}>
                                    Save
                                </button>
                                {/* <button type="button">Reset</button> */}
                            </div>
                        </div>
                    )}
            </form>
        </div>
    );
}

export default Otherinfo;
